import logoImage from '../images/10X Logo.png'

const LogoSVG = ({ width = '68', height = '32' } = {}): JSX.Element => {
  return <img src={logoImage} alt="10X logo" width={width} height={height} />
}

export default LogoSVG
